 <div *ngIf="prot()!==''; else other_content" class="container py-3">
      <div class="jumbotron">
        <div class="container">
          <h2 class="display-4">{{ this.i18n.end.info1 }}</h2>
          <h3>{{ this.i18n.end.info2 }}</h3>
          <h3>{{ this.i18n.end.info3 }} {{ prot() }}</h3>
        </div>
      </div>

      <div id="content">
        <formio id="formio-full"
                [language]="language"></formio>
      </div>

      <div>
        <button type="button" (click)="downloadAsPDF()" class="btn btn-primary btn-lg">
          {{ this.i18n.end.downloadPDF }}
        </button>
      </div>
</div>


<ng-template #other_content>
  <div class="container py-3">
    <div class="jumbotron">
      <div class="container">
        <h2 class="display-4">La segnalazione è stata inviata con successo.</h2>
        <h3>ID della sottomissione: {{submission}}</h3>
        <p>In attesa di assegnazione del protocollo...</p>

        <div class="text-center">
          <img src="../../../assets/img/loader.gif " class="img-fluid" alt="Responsive image">
        </div>

      </div>
    </div>
  </div>
</ng-template>
